import Vue from "vue";
import VueRouter from "vue-router";
import AuthRoutes from "./views/pages/Auth/router";
import MyDataRoutes from "./views/pages/MyData/router";
import ExamStatusRoutes from "./views/pages/ExamStatus/router";
import FinanceInfoRoutes from "./views/pages/FinanceInfo/router";
import MyExamsRoutes from "./views/pages/MyExams/router";
import QuestionsRoutes from "./views/pages/Questions/router";
import HomeRoutes from './views/pages/Home/router';
import ConfiguracoesRoutes from './views/pages/configuracoes/router';
import PageNotFoundRoutes from './views/pages/ForaDoAr/router';
import CarteiraMovimentacaoRoutes from './views/pages/Carteira/router';
import LiquidezRoutes from './views/pages/Liquidez/router';
import GestaoUsuariosRoutes from './views/pages/GestaoUsuarios/router';
import DashboardRoutes from './views/pages/Dashborard/router';
import SelecaoAssinaturaRoutes from './views/pages/SelecaoAssinatura/router';
import VisaoGeralRoutes from './views/pages/VisaoGeral/router';
import RentabilidadeRoutes from './views/pages/Rentabilidade/router';
import EscolhaPerfilRoutes from './views/pages/EscolhaPerfil/router';
import CheckoutRoutes from './views/pages/Checkout/router';
import PerfilRoutes from "./views/pages/Perfil/router";
import moment from "moment";
import EventBus from './views/Bus/bus';
import ReportTablesRoutes from './views/pages/Report/router';
import ReportMonthRoutes from './views/pages/ReportMonth/router';
import ImportacaoRoutes from "./views/pages/Importacao/router";
import TermsRoutes from "./views/pages/TermsAndConditions/router";
import MfaRoutes from "./views/pages/Mfa/router";
import ApiService from "./services/ApiService";

Vue.use(VueRouter);

const routes = [
  {
    ...PageNotFoundRoutes
  },
  {
    path: '/perfil',
    ...PerfilRoutes
  },
  {
    path: "/rentabilidade",
    ...RentabilidadeRoutes
  },
  {
    path: "/escolha-de-perfil",
    ...EscolhaPerfilRoutes
  },
  {
    path: "/selecao-de-assinatura",
    ...SelecaoAssinaturaRoutes
  },
  {
    path: "/report-tables",
    ...ReportTablesRoutes
  },
  {
    path: "/ReportMonth",
    ...ReportMonthRoutes
  },
  {
    path: "/importacao",
    ...ImportacaoRoutes
  },
  {
    path: '/checkout',
    ...CheckoutRoutes
  },
  {
    path: "/visao-geral",
    ...VisaoGeralRoutes
  },

  {
    path: "/gestao-usuario",
    ...GestaoUsuariosRoutes
  },
  {
    path: "/dashboard",
    ...DashboardRoutes
  },
  {
    path: "/liquidez",
    ...LiquidezRoutes
  },
  {
    path: "/carteira",
    ...CarteiraMovimentacaoRoutes
  },
  {
    path: "/auth",
    ...AuthRoutes
  },
  {
    path: "/",
    //redirect: "/auth",
    /* solução para mode: "history", tem que adicionar redirect no Web.config */
    beforeEnter: (to, _, next) => {
      next({
        path: to.query.path ? decodeURIComponent(to.query.path) : "/auth",
        query: to.query.path ? {} : to.query,
        hash: to.hash
      });
    }
  },
  {
    path: '/home',
    ...HomeRoutes
  },
  {
    path: "/exams",
    ...MyExamsRoutes
  },
  {
    path: "/exam",
    ...ExamStatusRoutes
  },
  {
    path: "/data",
    ...MyDataRoutes
  },
  {
    path: "/finance",
    ...FinanceInfoRoutes
  },
  {
    path: "/questions",
    ...QuestionsRoutes
  },
  {
    path: "/configuracoes",
    ...ConfiguracoesRoutes
  },
  {
    path: "/termsAndCoditions",
    ...TermsRoutes
  },
  {
    path: "/mfa",
    ...MfaRoutes
  }
];

const router = new VueRouter({
  mode: "history",
  /* solução para redirecionamento padrão */
  //mode: "hash",
  base: process.env.BASE_URL,
  routes
});

function isMobile() {
  return /Mobi|Android|iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

router.beforeEach(async (to, from, next) => {
  const token = sessionStorage.getItem("token");
  const expiresToken = new Date(sessionStorage.getItem("expires"));
  const user = JSON.parse(sessionStorage.getItem("user"));

  if (user && !user.acceptTerms) {
    if (to.path !== '/terms-and-conditions') {
      next('/terms-and-conditions');
      return;
    }
  }

  if (to.meta.requiresAuth) {
    if (token) {
      if (moment().isBefore(moment(expiresToken))) {

        if (isMobile() && from.path === "/auth" && to.path === "/gestao-usuario") {
          next("/report-tables");
          return;
        }

        if (from.path === '/auth') {
          const planRedirects = {
            0: to.meta.requiresBasic,
            1: to.meta.requiresPattern,
            2: to.meta.requiresSenior,
            3: to.meta.requiresExpert,
            4: to.meta.requiresProfessional
          };

          const permitido = planRedirects[user.planType];

          if (!permitido) {
            next(false);
            EventBus.$emit("abrirModalPlanos", true);
            return;
          }
        }
        next();
      } else {
        new ApiService().logout(router);
      }
    } else {
      next('/auth');
    }
  } else {
    next();
  }
});

export default router;
